import { ColumnGroup } from "./column-group";
import { resourcesNeededColumnGroup } from "./needed/needed-column-group";
import { allResourcesColumnGroup } from "./resource/resources-column-group";

export const allColumnGroup = new ColumnGroup(
  "1c564328-4525-4f8b-a7ec-868d740a5895",
  "All",
  [...allResourcesColumnGroup.columns, ...resourcesNeededColumnGroup.columns]
)
